export default __webpack_public_path__ + "static/media/splash-star.35ca3eaf.png";